{
  "(optional)": "(valgfrit)",
  "(required)": "(påkrævet)"
}